import Vue from 'vue'
import App from './App.vue'
import routerconfig from './router/index'
import VueRouter from 'vue-router'
import store from './store'
import './assets/css/common.scss'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import _ from 'lodash'
import qs from 'qs'
import numeral from 'numeral'

// 导入vue-echarts插件
import vueECharts from 'vue-echarts/components/ECharts.vue'
import echarts from 'echarts';



import animate from 'animate.css';
import axios from 'axios'

import r_code from './utils/r_code'
import echart_color from './utils/echart_color'
import arcgisCPT from "./components/ArcGISMapCPT";
import public_function from '../public/public_function'
import moment from 'moment'
import font from './assets/fonts/font.css'
import './assets/fonts/iconfont.css'
import './assets/fonts/lams/iconfont.css'

import scroll from 'vue-seamless-scroll'

import VueCookies from 'vue-cookies'
import JsonViewer from 'vue-json-viewer'

Vue.use(JsonViewer)

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(animate)
Vue.use(VueCookies)
axios.defaults.timeout = 50000;
Vue.prototype.$moment = moment
Vue.component('arcgisCPT', arcgisCPT)
Vue.component('v-chart', vueECharts)
Vue.prototype.$http = axios;
Vue.prototype.$store = store;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.font = font;
Vue.prototype.r_code = r_code;
Vue.prototype.echart_color = echart_color;
Vue.prototype.public_function = public_function;
Vue.prototype._ = _;
Vue.prototype.qs = qs;
Vue.prototype.$numeral = numeral;
Vue.prototype.Base64 = require('js-base64').Base64;
// Vue.use(ElementUI);
Vue.use(Antd);
Vue.use(scroll)

var router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: routerconfig
});

Vue.filter("dateformat", function (dataStr, pattern = "YYYY-MM-DD HH:mm:ss") {
  return moment(dataStr).format(pattern);
});


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  if (to.meta.title && to.meta.title != "SH3H") {
    document.title = to.meta.title
  } else if (to.meta.title != "SH3H") {
    document.title = "code";
  }
  next();
});

var mainvue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export {
  router,
  store,
  mainvue
}